"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64ToUrlSafeBase64 = exports.calculateAmount = exports.getEstimatedFees = exports.estimatedFeeSafetyRate = void 0;
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const js_estimateMaxSpendable_1 = __importDefault(require("./js-estimateMaxSpendable"));
exports.estimatedFeeSafetyRate = 2;
function getEstimatedFees() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { data } = yield (0, network_1.default)({
                method: "GET",
                url: "https://countervalues.live.ledger.com/latest/direct?pairs=hbar:usd",
            });
            return new bignumber_js_1.default(10000).dividedBy(data[0]);
        }
        catch (_a) {
            // as fees are based on a currency conversion, we stay
            // on the safe side here and double the estimate for "max spendable"
            return new bignumber_js_1.default("150200").multipliedBy(exports.estimatedFeeSafetyRate); // 0.001502 ℏ (as of 2023-03-14)
        }
    });
}
exports.getEstimatedFees = getEstimatedFees;
function calculateAmount({ account, transaction, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const amount = transaction.useAllAmount
            ? yield (0, js_estimateMaxSpendable_1.default)({ account })
            : transaction.amount;
        return {
            amount,
            totalSpent: amount.plus(yield getEstimatedFees()),
        };
    });
}
exports.calculateAmount = calculateAmount;
// NOTE: convert from the non-url-safe version of base64 to the url-safe version (that the explorer uses)
function base64ToUrlSafeBase64(data) {
    // Might be nice to use this alternative if .nvmrc changes to >= Node v14.18.0
    // base64url encoding option isn't supported until then
    // Buffer.from(data, "base64").toString("base64url");
    return data.replace(/\//g, "_").replace(/\+/g, "-");
}
exports.base64ToUrlSafeBase64 = base64ToUrlSafeBase64;
//# sourceMappingURL=utils.js.map